<template>
  <div class="loginBut" @click="goShowMyCenter">
    <div v-if="userInfo" class="default"></div>
    <span class="loginBut_title">用户</span>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: "LoginBut",
  data() {
    return {

    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {

  },
  methods: {
    goShowMyCenter() {
      this.$parent.goShowMyCenter(true);
    },
    goLogin(val) {
      this.$parent.goLogin(val);
    }
  }
}
</script>
<style lang="scss">
:root{
    --scale:1,
}
$scale:var(--scale, 1);
.loginBut{
    cursor: pointer;
    position: fixed;
    top: calc(#{$scale} * 40px);
    right: calc(#{$scale} * 180px);
    width:  calc(#{$scale} * 95px);
    height: calc(#{$scale} * 55px);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: calc(#{$scale} * 10px);
    overflow: hidden;
    background-color: rgba(0,0,0,0.5);
    &:hover{
      background-color: rgba(0,0,0,0.8);
        .loginBut_title{
            color: #F5BC41;
        }
        .default{
            background-image: url('~@/assets/img/new-user-hover.png');
        }
    }

    .default{
        display:inline-block;
        width:calc(#{$scale} * 30px);
        height: calc(#{$scale} * 30px);
        background-image: url('~@/assets/img/new-user.png');
        background-size:calc(#{$scale} * 30px) calc(#{$scale} * 30px);
        background-position: center center;
        background-repeat: no-repeat;
        margin-right: 6px;
    }
    .loginBut_title{
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: calc(#{$scale} * 15px);
        color: #FFFFFF;
        text-align: center;
        font-style: normal;
      }
}
 </style>
